import { Badge, Slider } from "antd";
import { BodyMap } from "../BodyMap/BodyMap";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { SORENESS_LEVELS } from "../../Utils/bodymap";
import { PAIN_LEVELS } from "../../Utils/bodymap";
import { useSelector } from "react-redux";
import "../../Styles/styles-BodyMapView.css";

const question_key_to_levels = {
  bodymap_soreness: SORENESS_LEVELS,
  bodymap_joint_pain: PAIN_LEVELS,
  bodymap_pain_discomfort: PAIN_LEVELS
};

export const BodyMapView = ({
  data = {},
  title = "",
  playersPage = false,
  question_key = "bodymap_soreness",
  showBothSides = false,
  showTitle = true,
  showDate = true,
  fitHeight = false,
}) => {
  const [slider, setSlider] = useState(0);
  const { gender } = useSelector(({ team }) => team.info);

  const dates = useMemo(
    () => Object.keys(data || {}).sort((a, b) => (a < b ? -1 : 1)),
    [data]
  );

  const formatter = (value) => `${dayjs(dates[value]).format("YYYY-MM-DD")}`;

  const bodyMap = useMemo(() => {
    if (dates.length === 0) return {};
    const dateString = formatter(slider);
    return data[dateString];
  }, [slider, dates]);

  useEffect(() => {
    setSlider(0);
  }, [data]);

  const marks = useMemo(() => {
    if (dates.length === 0) return {};
    return dates.reduce((acc, curr, ind) => {
      acc[ind] = (
        <div style={{ fontSize: 12, fontWeight: "bold", whiteSpace: "nowrap" }}>
          {dayjs.utc(curr).format("M-D")}
        </div>
      );
      return acc;
    }, {});
  }, [dates]);

  const getBodymapLevels = (questionKey) => {
    return question_key_to_levels[questionKey] ?? question_key_to_levels["bodymap_soreness"];
  }

  return !data || dates.length === 0 ? (
    <></>
  ) : (
    <div
      style={
        fitHeight
          ? { width: "100%", height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }
          : { width: "100%" }
      }
    >
      {showTitle && title ? <p className="teamdata-graph-titles">{title}</p> : null}
      {playersPage ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
            marginBottom: 24,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getBodymapLevels(question_key).map((level, index) => (
            <div
              key={index}
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: level.color,
                  borderRadius: 5,
                }}
              />
              <span style={{ fontSize: 11 }}>{level.label}</span>
            </div>
          ))}
        </div>
      ) : null}

      {showBothSides ? (
        <div className={`bodymap-both-sides${fitHeight ? " bodymap-both-sides--fit" : ""}`}>
          <BodyMap playersPage={playersPage} data={bodyMap} gender={gender} forcedSide="front" fitHeight={fitHeight} />
          <BodyMap playersPage={playersPage} data={bodyMap} gender={gender} forcedSide="back" fitHeight={fitHeight} />
        </div>
      ) : (
        <BodyMap playersPage={playersPage} data={bodyMap} gender={gender} fitHeight={fitHeight} />
      )}
      {showDate && (
        <div style={{ fontWeight: "bold", fontSize: 16 }}>{dates[slider]}</div>
      )}
      {dates.length > 1 && (
        <Slider
          max={dates.length - 1}
          marks={marks}
          value={slider}
          onChange={setSlider}
          step={null}
          tooltip={{ formatter, placement: "left" }}
          style={{ marginTop: 24 }}
        />
      )}
    </div>
  );
};
